/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Объект для представления запроса на обновление уведомлений
 */
export interface NotificationUpdateRequest {
  notificationIds?: string[];
}

/**
 * Шаблонов уведомлений
 */
export interface NotificationTemplate {
  /**
   * Идентификатор шаблона
   * @format uuid
   */
  id: string;

  /** Продукт шаблона */
  product?: string;

  /** Наименование шаблона */
  name: string;

  /** Текст шаблона */
  text: string;

  /** Код ситемы или МС кому пренадлежит система */
  systemCode?: string;
}

/**
 * Список добавляемых шаблонов уведомлений
 */
export interface NotificationTemplateList {
  /** Не именованный список шаблонов */
  notifTemplateRegs: NotificationTemplate[];
}

/**
 * Продукт в канале
 */
export interface ProductChannel {
  /**
   * Идентификатор продукта в канале
   * @format uuid
   */
  id?: string;

  /** Код продукта */
  product: string;

  /** Наименование продукта */
  name: string;

  /** Описание продукта */
  comment?: string;

  /** Код систкмы или МС чей продукт */
  system: string;

  /** Канал уведомления */
  channel: string;

  /** Признак возможности изменения подписки через интерфейс */
  isSubscription?: boolean;

  /** Значение подписки по умолчанию */
  isActive?: boolean;
}

export interface NewNotificationReqMessage {
  action?: string;
  externalId?: string;
  externalSystem?: string;

  /** @format date-time */
  notifyDate?: string;
  clientId?: string;
  clientIds?: string[];
  clientIdOwb?: boolean;
  userId?: string;
  userIdOwb?: boolean;
  branchId?: string;
  branchIds?: string[];
  branchIdOwb?: boolean;
  subject?: string;
  body?: string;
  additionalValues?: Record<string, string>;

  /** Данные для шаблонизатора */
  subjectTemplate?: TemplateRequest;

  /** Данные для шаблонизатора */
  bodyTemplate?: TemplateRequest;
  sender?: string;
  attachmentFsIds?: string[];
  recipient?:
    | "USER"
    | "CLIENT_USERS"
    | "LIST_CLIENT_USERS"
    | "BRANCH_USERS"
    | "LIST_BRANCH_USERS"
    | "ALL";
  channels?: ("PUSH" | "CENTER" | "MAIL" | "EMAIL" | "SMS")[];
  product?: string;
}

/**
 * Данные для шаблонизатора
 */
export interface TemplateRequest {
  /**
   * Идентификатор шаблона
   * @format uuid
   */
  id?: string;

  /** Данные для шаблона */
  data?: Record<string, string>;
}

/**
 * Изменение подписки
 */
export interface ChannelSubscription {
  /** Канал, которому изменяем подписку */
  channel: string;

  /** Значение подписки */
  isActive: boolean;

  /**
   * Идентификатор подписки
   * @format uuid
   */
  subscrId?: string;
}

/**
 * Изменение подписки
 */
export interface ProductSubscription {
  /**
   * Идентификатор продукта в канале
   * @format uuid
   */
  id: string;

  /**
   * Идентификатор подписки пользователя
   * @format uuid
   */
  subscrId?: string;

  /** Значение подписки */
  isActive?: boolean;
}

/**
 * Каналов, которому принадлежит уведомление
 */
export interface ChannelActiveResponse {
  /** Канал, в котором есть продукты, на которые можно подписаться */
  code?: string;

  /** Признак подписки */
  isActive?: boolean;
}

/**
 * Каналов, в котором продукт шлет уведомления
 */
export interface ChannelResponse {
  /** Канал, в котром будет отправлено уведомление */
  code?: string;

  /** Признак подписки */
  isActive?: boolean;

  /**
   * Идентификатор продукта в канале
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор подписки
   * @format uuid
   */
  subscrId?: string;

  /** Признак возможности изменения подписки на продукт в канале */
  isSubscription?: boolean;
}

/**
 * Подписки на продукты
 */
export interface ProductChannelResponse {
  /** Список продуктов, по которым отправляются уведомления */
  productResponses?: ProductResponse[];

  /** Список каналов, которым принадлежат уведомления */
  channelActiveResponses?: ChannelActiveResponse[];
}

/**
 * Продукт по которому отправляются уведомления
 */
export interface ProductResponse {
  /** Список каналов, в которых продукт шлет уведомления */
  channelResponses?: ChannelResponse[];

  /** Код продукта */
  product?: string;

  /** Наименование продукта */
  name?: string;

  /** Описание продукта */
  comment?: string;
}

/**
 * Оповещение
 */
export interface NotificationItemResponse {
  /**
   * Уникальный идентификатор
   * @format uuid
   */
  id: string;

  /**
   * Дата оповещения
   * @format date-time
   */
  date: string;

  /** Признак важности */
  isImportant: boolean;

  /** Тема */
  subject: string;

  /** Текст */
  body: string;

  /** Новое или нет (уже прочитано или нет) */
  isNew: boolean;

  /** Было ли очищено */
  isCleared: boolean;

  /** Имя линка */
  linkName: string;

  /** Диплинк или внешняя гиперссылка */
  linkUrl: string;
}

/**
 * Объект для представления ответа на запрос получения списка оповещений
 */
export interface NotificationResponse {
  /**
   * Количество строк всего
   * @format int32
   */
  total: number;

  /**
   * Количество страниц всего
   * @format int32
   */
  pages: number;

  /** Есть ли еще записи */
  hasMore: boolean;

  /** Оповещения */
  items: NotificationItemResponse[];
}

/**
 * Список каналов пользователя
 */
export interface ChannelSubscriptionResponse {
  /**
   * Идентификатор подписки
   * @format uuid
   */
  subscrId?: string;

  /** Код канала уведомления */
  channel: string;

  /** Наименование канала */
  name: string;

  /** Тип канала */
  type?: string;

  /** Значение подписки */
  isActive: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Cервис внутренних уведомлений ДБО
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://ms-dbo-notifications.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Коммуникации <info@rshbintech.ru>
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Центр уведомлений
     * @name GetAll
     * @summary Получить все уведомления
     * @request GET:/api/dbo-notifications/v1/external/notifications
     * @secure
     */
    getAll: (
      query?: {
        dateFrom?: string;
        dateTo?: string;
        page?: number;
        size?: number;
        read?: boolean;
        important?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationResponse, void>({
        path: `/api/dbo-notifications/v1/external/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Центр уведомлений
     * @name MarkChanged
     * @summary Обновить статус 'прочтено' или 'очищено' для уведомления
     * @request PUT:/api/dbo-notifications/v1/external/notifications
     * @secure
     */
    markChanged: (
      data: NotificationUpdateRequest,
      query?: { cleared?: boolean; read?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<number, void>({
        path: `/api/dbo-notifications/v1/external/notifications`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Центр уведомлений
     * @name MarkDeleted
     * @summary Установить статус 'удалено' для уведомления
     * @request DELETE:/api/dbo-notifications/v1/external/notifications
     * @secure
     */
    markDeleted: (
      data: NotificationUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<number, void>({
        path: `/api/dbo-notifications/v1/external/notifications`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Обмен данными с Abs
     * @name PostResponse
     * @summary Получение ответа от Abs
     * @request POST:/api/v1/abs/response/sendSMS
     * @secure
     */
    postResponse: (data: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/abs/response/sendSMS`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name NotificationTemplatesRegistration
     * @summary Регистрация шаблонов
     * @request POST:/api/dbo-notifications/v1/internal/template/reg
     * @secure
     */
    notificationTemplatesRegistration: (
      data: NotificationTemplateList,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/template/reg`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name TemplatesRegistration
     * @summary Регистрация шаблонов
     * @request POST:/api/dbo-notifications/v1/internal/template-reg
     * @secure
     */
    templatesRegistration: (data: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/template-reg`,
        method: "POST",
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписки на уведемления
     * @name ProductChannelRegistration
     * @summary Регистрация и обновление  продуктов
     * @request POST:/api/dbo-notifications/v1/internal/product-channel
     * @secure
     */
    productChannelRegistration: (
      data: ProductChannel[],
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/product-channel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Новое уведомление
     * @name SendNew
     * @summary Отправка уведомления в каналы
     * @request POST:/api/dbo-notifications/v1/internal/new
     * @secure
     */
    sendNew: (data: NewNotificationReqMessage, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/new`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Фильтры уведомлений
     * @name ImportantListGet
     * @summary Выгрузить список важных тем
     * @request GET:/api/dbo-notifications/v1/internal/filter/important_list
     * @secure
     */
    importantListGet: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/filter/important_list`,
        method: "GET",
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Фильтры уведомлений
     * @name ImportantListPost
     * @summary Загрузить список важных тем
     * @request POST:/api/dbo-notifications/v1/internal/filter/important_list
     * @secure
     */
    importantListPost: (data: { document: File }, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/filter/important_list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Фильтры уведомлений
     * @name IgnoreListGet
     * @summary Выгрузить список игнорируемых тем
     * @request GET:/api/dbo-notifications/v1/internal/filter/ignore_list
     * @secure
     */
    ignoreListGet: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/filter/ignore_list`,
        method: "GET",
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Фильтры уведомлений
     * @name IgnoreListPost
     * @summary Загрузить список игнорируемых тем
     * @request POST:/api/dbo-notifications/v1/internal/filter/ignore_list
     * @secure
     */
    ignoreListPost: (data: { document: File }, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/filter/ignore_list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписки на уведемления. Клиент
     * @name ChannelSubscription
     * @summary Подписка пользователя на канал
     * @request POST:/api/dbo-notifications/v1/external/subscribe-channel
     * @secure
     */
    channelSubscription: (
      data: ChannelSubscription,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/external/subscribe-channel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписки на уведемления. Клиент
     * @name ChangeProductSubscription
     * @summary Изменение подписки на продукт
     * @request POST:/api/dbo-notifications/v1/external/product-subscription
     * @secure
     */
    changeProductSubscription: (
      data: ProductSubscription,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/external/product-subscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Первичная публикация репликаций
     * @name RunFullClientReplication
     * @summary Запрос на запуск полной репликации клиентов (организаций)
     * @request GET:/api/dbo-notifications/v1/internal/client-replication
     * @secure
     */
    runFullClientReplication: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/client-replication`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Первичная публикация репликаций
     * @name RunFullBranchReplication
     * @summary Запрос на запуск полной репликации филиалов
     * @request GET:/api/dbo-notifications/v1/internal/branch-replication
     * @secure
     */
    runFullBranchReplication: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/dbo-notifications/v1/internal/branch-replication`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписки на уведемления. Клиент
     * @name GetProductChannelSubscription
     * @summary Получение подписок на продукты
     * @request GET:/api/dbo-notifications/v1/external/product_channel
     * @secure
     */
    getProductChannelSubscription: (params: RequestParams = {}) =>
      this.request<ProductChannelResponse, void>({
        path: `/api/dbo-notifications/v1/external/product_channel`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Центр уведомлений
     * @name GetUnreadCount
     * @summary Получить количество не прочтенных уведомлений
     * @request GET:/api/dbo-notifications/v1/external/notifications/unreadCount
     * @secure
     */
    getUnreadCount: (params: RequestParams = {}) =>
      this.request<number, void>({
        path: `/api/dbo-notifications/v1/external/notifications/unreadCount`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписки на уведемления. Клиент
     * @name GetChannelSubscription
     * @summary Подключенные каналы
     * @request GET:/api/dbo-notifications/v1/external/channel-subscription
     * @secure
     */
    getChannelSubscription: (params: RequestParams = {}) =>
      this.request<ChannelSubscriptionResponse[], void>({
        path: `/api/dbo-notifications/v1/external/channel-subscription`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
